import { render, staticRenderFns } from "./manualRules.vue?vue&type=template&id=a0e62d5a&scoped=true&"
import script from "./manualRules.vue?vue&type=script&lang=js&"
export * from "./manualRules.vue?vue&type=script&lang=js&"
import style0 from "./manualRules.vue?vue&type=style&index=0&id=a0e62d5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e62d5a",
  null
  
)

export default component.exports